
import FiltroAsignaciones from '@/model/filtros/FiltroAsignaciones';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { agrupacionesStore } from '@/store/AgrupacionesStore';
import { fuerosStore } from '@/store/FuerosStore';
import Agrupacion from '@/model/Agrupacion';
import Profesion from '@/model/Profesion';
import { getData } from '@/api/ProfesionesApi';
import { getZonas } from '@/api/ZonasApi';
import Fuero from '@/model/Fuero';
import Zona from '@/model/Zona';
import { compararPeriodos, getDateFromDDMMYYYY } from '@/utils/DateUtil';
import { loaderStore } from '@/store/LoaderStore';
import { notifyError } from '@/utils/NotifyUtils';

@Options({
  components: {},
  name: 'FiltrosAsignaciones',
})
export default class FiltrosAsignaciones extends Vue {
  async mounted() {
    if (agrupacionesStore.getState().length === 0) {
      await agrupacionesStore.loadAgrupaciones();
    }
    if (fuerosStore.getState().length === 0) {
      fuerosStore.loadFueros();
    }
  }

  @Prop()
  private filtro!: FiltroAsignaciones;
  private agrupaciones: Agrupacion[] = agrupacionesStore.getState();
  private fueros: Fuero[] = fuerosStore.getState();
  private diasAnteriores = 30;
  private profesiones: Profesion[] = [];
  private zonas: Zona[] = [];
  private loadingAgrupaciones = false;
  private get minMonYear() {
    const hoy = new Date();
    const inicio = new Date();
    inicio.setDate(hoy.getDate() - this.diasAnteriores);
    const anio = `${inicio.getUTCFullYear()}`;
    const mes = inicio.getUTCMonth() + 1 < 10 ? `0${inicio.getUTCMonth() + 1}` : `${inicio.getUTCMonth() + 1}`;

    return `${anio}/${mes}`;
  }
  private get maxMonYear() {
    const hoy = new Date();
    const anio = `${hoy.getUTCFullYear()}`;
    const mes = hoy.getUTCMonth() + 1 < 10 ? `0${hoy.getUTCMonth() + 1}` : `${hoy.getUTCMonth() + 1}`;
    return `${anio}/${mes}`;
  }

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      resetValidation(): void;
    };
  }
  optionsFn(date: string) {
    const hoy = new Date();
    const inicio = new Date();
    inicio.setDate(hoy.getDate() - this.diasAnteriores);
    return compararPeriodos(inicio, new Date(date), hoy);
  }

  validate() {
    return this.form().validate();
  }
  filterAgrupaciones(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.agrupaciones = agrupacionesStore.getState();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.agrupaciones = agrupacionesStore.getState().filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }
  filterProfs(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.updateProfesiones();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.profesiones = this.profesiones.filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }
  filterFueros(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.fueros = fuerosStore.getState();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.fueros = fuerosStore.getState().filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }
  filterZonas(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.updateZonas();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.zonas = this.zonas.filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }
  resetValidation() {
    this.form().resetValidation();
  }
  private validarSelect(val: string | null) {
    if (val === null) {
      return 'Debe seleccionar una opción';
    }
  }
  private validarFecha(val: string | null) {
    return val === null || val === '' ? 'Debe seleccionar una fecha' : true;
  }
  private validarMayor(val: string | null) {
    if (val && this.filtro.fechaDesde && getDateFromDDMMYYYY(this.filtro.fechaDesde) > getDateFromDDMMYYYY(val)) {
      return 'La fecha "Desde" debe ser menor a la fecha "Hasta"';
    } else return true;
  }
  @Watch('filtro.agrupacion')
  async updateProfesiones() {
    if (this.filtro.agrupacion) {
      try {
        this.profesiones = await getData(this.filtro.agrupacion.id);
      } catch (err) {
        notifyError(err);
        this.profesiones = [];
      } finally {
        this.filtro.profesion = null as unknown as Profesion;
      }
    } else {
      this.profesiones = [];
    }
    this.filtro.profesion = null as unknown as Profesion;
  }
  @Watch('filtro.fuero')
  async updateZonas() {
    if (this.filtro.fuero) {
      try {
        this.zonas = await getZonas(this.filtro.fuero.id);
      } catch (err) {
        notifyError(err);
        this.zonas = [];
      } finally {
        this.filtro.zona = null as unknown as Zona;
      }
    } else {
      this.zonas = [];
    }
  }
  private get watcher() {
    return loaderStore.getState().loading;
  }
}
